import { cva, NoddiIcon } from 'noddi-ui-common';
import { catalogPowerSummary } from 'noddi-util';

type Props = {
  kilowatts: number;
  compact?: boolean;
};

const powerLabelVariants = cva('inline-flex min-w-0 gap-x-1.5 gap-y-0.5 tabular-nums', {
  variants: {
    compact: {
      true: 'flex-col items-end text-xs text-muted-foreground',
      false: 'flex-wrap items-center'
    }
  }
});

export const NavioPowerLabel = ({ kilowatts, compact = false }: Props) => {
  const power = catalogPowerSummary(kilowatts);
  return (
    <span className={powerLabelVariants({ compact })}>
      <span className='whitespace-nowrap'>{power.kilowatts}</span>
      <span className='inline-flex items-center gap-1 whitespace-nowrap'>
        <NoddiIcon name='Horse' size='small' />
        {power.horsepower}
      </span>
    </span>
  );
};
